var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "显示标题栏" } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.showHeader,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "showHeader", $$v)
          },
          expression: "optionModel.showHeader",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }